export default ({ itemName }) => {
  const localStorage = window.localStorage && window.localStorage.getItem(itemName);
  return localStorage === null ? {} : JSON.parse(localStorage);
};
